export function onlyNumberDotComma(s: string) {
  return s.replace(/[^\d.,-]/g, "");
}

export function normalizeDecimalInput(s: string) {
  const cleaned = onlyNumberDotComma(s).trim();
  if (!cleaned) return "";

  const hasComma = cleaned.includes(",");
  const hasDot = cleaned.includes(".");

  if (hasComma && hasDot) {
    return cleaned.replace(/\./g, "").replace(",", ".");
  }
  if (hasComma && !hasDot) return cleaned.replace(",", ".");
  return cleaned;
}

export function formatBRLFromNumericString(value: string) {
  const normalized = normalizeDecimalInput(value);
  const n = Number(normalized);
  if (!Number.isFinite(n)) return "";
  return n.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}

export function parseBRLToNumericString(value: string) {
  const cleaned = value.replace(/\s/g, "").replace("R$", "");
  return normalizeDecimalInput(cleaned);
}

export function moneyBRL(v: any) {
  const n = Number(String(v ?? "0").replace(",", "."));
  if (!Number.isFinite(n)) return "R$ 0,00";
  return n.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}
